<template>
  <h1
    class="title"
    :class="mySize">
    <slot></slot>
  </h1>
</template>

<script>

export default {
  props: {
    size: {
      type: String,
      default: '4'
    }
  },

  computed: {
    mySize () {
      return `is-${this.size}`
    }
  }
}
</script>
